//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapMutations, mapState} from 'vuex'
import {attributesMixin} from '@/mixins/attributesMixin'
import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import ShoppingCartDeleteDialog from '@/frontend/components/common/shopping-cart-delete-dialog.vue'
import {customAttributeCodes} from '@/frontend/enums/customAttributeCodes'
export default {
  name: 'ShoppingCart',
  components: {ShoppingCartDeleteDialog},
  mixins: [columnFormatterMixin, attributesMixin],
  data: () => {
    return {
      confirmationDialogVisibility: false,
      cartLoading: true,
      couponCode: '',
      currentItemId: undefined,
    }
  },
  computed: {
    ...mapState('shoppingCart', [
      'cartItems',
      'cartItemCount',
      'salesTax',
      'shippingPrice',
      'subTotal',
      'grandTotal',
      'discountValue',
    ]),
    cartItemsWithAttributes() {
      return this.cartItems.map((item) => {
        return {
          attributes: item.itemTypeData?.attributes
            .filter((attribute) => !this.isStullerItem(attribute))
            .map((attribute) => {
            return this.mapAttributeValue(attribute)
          }),
          isStullerItem: item.itemTypeData?.attributes
            .some((attribute) => this.isStullerItem(attribute)),
          ...item,
        }
      })
    },
    discountApplied() {
      return this.discountValue && this.discountValue > 0
    },
  },
  watch: {
    cartItems: {
      handler(val) {
        this.updateSubTotal()
        this.updateGrandTotal()
      },
      deep: true,
    },
  },
  async mounted() {
    this.cartLoading = true
    await this.frontendGetBySessionId()
    await this.fetchDiscountValue()
    this.cartLoading = false
  },
  methods: {
    ...mapActions('shoppingCart', [
      'frontendGetBySessionId',
      'deleteCartItemFrontend',
      'getSalesTax',
      'fetchDiscountValue',
    ]),
    ...mapMutations('shoppingCart', ['updateSubTotal', 'updateGrandTotal', 'setDiscountValue']),
    editCartItem(cartItem) {
      this.$router.push(`/product/${cartItem.itemTypeData?.itemSku}?cartItemId=${cartItem.id}`)
    },
    async deleteCartItem() {
      try {
        if (!this.currentItemId) {
          return
        }

        await this.deleteCartItemFrontend(this.currentItemId)

      } finally {
        this.currentItemId = undefined
        this.closeDialog()
      }
    },
    closeDialog() {
      this.confirmationDialogVisibility = false
      this.currentItemId = undefined
    },
    deleteCartItemDialog(itemID) {
      this.confirmationDialogVisibility = true
      this.currentItemId = itemID
    },
    applyCoupon() {
      const cartId = this.cartItems[0]?.cartID
      this.$axios.$put(`/coupon/apply-coupon/${this.couponCode}/${cartId}`).then((response) => {
        if (response.hasErrors) {
          this.$toast.error(response.errorMessages[0].value)
        }
        else{
          this.setDiscountValue({discountValue: response.value.discountValue})
          this.$toast.success('Coupon applied')
        }
      })
    },
    checkout() {
      this.$router.push('/checkout')
    },
    isStullerItem(attribute) {
      return attribute.code.replace(" ", "") === customAttributeCodes.StullerItem &&
             attribute.value &&
             attribute.value === "1"
    }
  },
}
